import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Grow from '@mui/material/Grow';
import { toIndianRupeeFormat } from '../custom';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Grow ref={ref} timeout={3000} {...props} />
});

const OrderSuccessDialog = ({ open, onClose, orderData, warning }) => {

    const isLimitOrder = orderData?.[0]?.order_type?.toLowerCase() === "limit";

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            TransitionComponent={Transition}
            keepMounted
            disableEscapeKeyDown
            PaperProps={{
                style: {
                    padding: '10px 0px',
                    borderRadius: '20px',
                    width: '360px',
                    boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.2)',
                    background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
                },
            }}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    pointerEvents: 'none',
                },
            }}
        >
            <DialogTitle />

            <DialogContent
                style={{
                    textAlign: 'center',
                    fontSize: '16px',
                    color: '#333',
                    padding: '0 24px 16px',
                }}
            >
                {/* Success Icon */}
                <div style={{ margin: '16px 0' }}>
                    <div
                        style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            backgroundColor: isLimitOrder ? '#e3f2fd' : '#e0f7e9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto',
                        }}
                    >
                        <span
                            style={{
                                fontSize: '32px',
                                color: isLimitOrder ? '#1976d2' : '#4caf50',
                            }}
                        >
                            ✓
                        </span>
                    </div>
                </div>

                {/* Heading */}
                <div
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: '20px',
                        color: isLimitOrder ? '#1976d2' : '#4caf50',
                        marginBottom: '10px',
                    }}
                >
                    {isLimitOrder
                        ? 'Order Limit Placed Successfully!'
                        : 'Order Placed Successfully!'}
                </div>
                {warning && (
                    <div
                        style={{
                            marginTop: '12px',
                            padding: '10px',
                            backgroundColor: '#fff3cd',
                            color: '#856404',
                            borderRadius: '8px',
                            fontSize: '13px',
                        }}
                    >
                        ⚠️ {warning}
                    </div>
                )}
                {/* Transaction Details */}
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 0 8px rgba(0,0,0,0.05)',
                        padding: '16px',
                        textAlign: 'left',
                        fontSize: '14px',
                    }}
                >
                    {[
                        ['Script Name', orderData?.[0]?.script_name],
                        ['Order Type', orderData?.[0]?.order_type],
                        ['Type', orderData?.[0]?.type?.charAt(0).toUpperCase() + orderData?.[0]?.type?.slice(1)],
                        ['Quantity', (orderData || []).reduce((sum, o) => sum + (Number(o?.qty) || 0), 0)],
                        ['Price', toIndianRupeeFormat(orderData?.[0]?.price)],
                        ['Status', '✅ Success'],
                    ].map(([label, value]) => (
                        <div
                            key={label}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '8px',
                            }}
                        >
                            <span style={{ color: '#999' }}>{label}</span>
                            <span
                                style={{
                                    fontWeight: label === 'Status' ? '600' : 'normal',
                                    color: label === 'Status' ? '#4caf50' : '#333'
                                }}
                            >
                                {value}
                            </span>
                        </div>
                    ))}
                </div>
            </DialogContent>
            {warning && (
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        style={{
                            backgroundColor: '#4caf50',
                            color: '#fff',
                            fontWeight: 'bold',
                            padding: '8px 20px',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(76, 175, 80, 0.4)',
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default OrderSuccessDialog;